import React from "react"
import { Input, Form, Col, Row, Alert } from "reactstrap"
import BrandRecomHighlightTable from "./BrandRecomHighlightTable"
import BrandRecomNomaroiTable from "./BrandRecomNomaroiTable"
import { Tab, TabGroup, TabList, TabPanels, TabPanel } from "@headlessui/react"

// Custom Hooks
import useTableController from "hooks/useTableController"

// Validation
import { SearchFilterSchema } from "model/_base/filters/filter-options.schema";

// API
import {
  useGetBrandRecomHighlightQuery,
  useGetBrandRecomNomaroiQuery,
} from "services/contents/api"

const BrandRecomTab = () => {
  // HOOK CHANGE
  const { formik, searchInput, setSearchInput, handleTableChange } =
    useTableController({
      initialValues: {},
      validationSchema: SearchFilterSchema,
    })

  // API
  const {
    data: dataHighlight,
    isLoading: isLoadingHighlight,
    error: errorHighlight,
  } = useGetBrandRecomHighlightQuery(formik.values)
  const {
    data: dataNomaroi,
    isLoading: isLoadingNomaroi,
    error: errorNomaroi,
  } = useGetBrandRecomNomaroiQuery(formik.values)

  // RENDER
  return (
    <Form
      className="form-horizontal w-100 d-flex flex-column gap-4"
      onSubmit={e => {
        e.preventDefault()
        formik.handleSubmit()
      }}
      data-testid="search-form"
    >
      <div className="brand-recom-tab" data-testid="brand-recom-tab">
        <div className="header mt-4">
          <h2 className="fw-semibold">ตั้งค่าเงินค่าคอมมิชชัน</h2>
          <div className="d-flex flex-column gap-2">
            <Row className="gy-3">
              <Col sm={12} md={12} lg={6} xl={{ size: 6 }}>
                <div className="d-flex gap-3">
                  <div className="flex-grow-1">
                    <div className="input-group-icon">
                      <i className="bx bx-search" />
                      <Input
                        name="searchTerm"
                        type="text"
                        placeholder="ค้นหารแบรนด์สินค้า"
                        onChange={e => setSearchInput(e.target.value)}
                        value={searchInput}
                        invalid={
                          formik.touched.searchTerm && formik.errors.searchTerm
                        }
                        data-testid="search-input"
                      />
                      {formik.touched.searchTerm &&
                        formik.errors.searchTerm && (
                          <div
                            className="error-message"
                            data-testid="search-error"
                          >
                            {formik.errors.searchTerm}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className="text-lg mt-2 mb-4">
          ค้นพบรายการแบรนด์แนะนำ ในระบบทั้งหมด *
          {/* {dataHighlight.pagination.total.toLocaleString()} รายการ * */}
        </div>

        <TabGroup>
          <TabList className="nav nav-tabs nav-tabs-custom">
            <Tab className="nav-link">แบรนด์ที่แนะนำ</Tab>
            <Tab className="nav-link">แบรนด์จาก Nomaroi</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <BrandRecomHighlightTable
                data={dataHighlight}
                error={errorHighlight}
                isLoading={isLoadingHighlight}
                onTableChange={handleTableChange}
              />
            </TabPanel>
            <TabPanel>
              <BrandRecomNomaroiTable
                data={dataNomaroi}
                error={errorNomaroi}
                isLoading={isLoadingNomaroi}
                onTableChange={handleTableChange}
              />
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </Form>
  )
}

export default BrandRecomTab
